module.exports = __webpack_public_path__ + "static/media/decoracao_02.4322c160.jpg";